/*
import Header from './Header';
import Footer from './Footer';
*/
import React, { useState } from "react";

import './App.css';
import './Header.css';
import './Footer.css';

import AppInterface from './AppInterface';
import './AppInterface.css';

import Crow from './Crow';

import Tos from './Tos';
import './Tos.css';

// import Feedback from './Feedback';
// import './Feedback.css';

// import Donate from './Donate';
// import './Donate.css';

const Home = () => (
    <div className='App'>
        <AppInterface />
        <Crow />
    </div>
);

const TosView = () => (
    <div>
        <Tos />
        <Crow />
    </div>
);

// const FeedbackView = () => (
//     <Feedback />
// );

// const DonateView = () => (
//     <Donate />
// );

const DonateView = () => {
    window.open("https://www.paypal.com/donate/?hosted_button_id=L9KYBC3CFR2ZA", "_blank");
};

function App () {
    const [currentView, setCurrentView] = useState(1);
    return(
        <div>
            <div className='header'>
                {currentView === 1 ?
                    <button className='logo' /> :
                    <button className='home' onClick={() => setCurrentView(1)}>&#60; back</button>
                }
            </div>

            {currentView === 1 ? <Home /> : null}
            {currentView === 2 ? <TosView /> : null}
            {/* {currentView === 3 ? <FeedbackView /> : null} */}
            {/* {currentView === 4 ? <DonateView /> : null} */}

            <div className='footer'>
                <div className="empty"></div>
                <div className="empty"></div>
                <button className='tos' onClick={() => setCurrentView(2)}>
                    Terms of Service
                </button>
                {/* <button className='feedback' onClick={() => setCurrentView(3)}>
                    Feedback
                </button> */}
                <button className='donate' onClick={DonateView}>
                    Donate
                </button>
                <div className="empty"></div>
                <div className="empty"></div>
            </div>
        </div>
    )
};

export default App;
